import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NoxTable from '../../component/Table';
import {
  fetchTextNotifications,
  downloadTextNotification
} from '../../actions/textNotificationAction';
import InnerHeader from '../../component/InnerHeader';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const TextNotification = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();

  const isLoaded = useSelector(({ emailNotification }) => emailNotification.isLoaded);
  const textNotifications = useSelector(
    ({ textNotification }) => textNotification.textNotifications
  );
  const currentProject = useSelector(({ project }) => project.currentProject);

  const onDownloadCsv = () => {
    dispatch(downloadTextNotification());
  };

  const onEmailDelete = () => {};

  const mapToTable = (textNotifications) => {
    const data = [];

    textNotifications?.forEach(({ _id, from, createdAt, fromName, to, subject }, index) => {
      data.push({
        createdAt: formatDate(createdAt),
        from,
        fromName,
        id: _id,
        key: index,
        subject,
        to
      });
    });

    return data;
  };

  const columns = [
    {
      dataIndex: 'from',
      key: 'from',
      render: (from) => {
        return <Copy text={from} />;
      },
      sorter: (a, b) => a.from.localeCompare(b.from),
      title: 'From'
    },
    {
      dataIndex: 'fromName',
      key: 'fromName',
      render: (fromName) => {
        return <Copy text={fromName} />;
      },
      sorter: (a, b) => a.fromName.toString().localeCompare(b.fromName),
      title: 'From Name'
    },
    {
      dataIndex: 'to',
      key: 'to',
      render: (to) => {
        return <Copy text={to} />;
      },
      sorter: (a, b) => a.to.toString().localeCompare(b.to),
      title: 'To'
    },
    {
      dataIndex: 'subject',
      key: 'subject',
      render: (subject) => {
        return <Copy text={subject} />;
      },
      sorter: (a, b) => a.subject.toString().localeCompare(b.subject),
      title: 'Subject'
    },
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => {
        return <Copy text={createdAt} />;
      },
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      title: 'Created At'
    }
  ];

  const actions = [
    {
      onClick: onDownloadCsv,
      title: 'Download .CSV',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: onEmailDelete,
      title: 'Delete'
    });
  }

  useEffect(() => {
    async function load() {
      dispatch(fetchTextNotifications());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const data = mapToTable(textNotifications);

  if (!currentProject) {
    return <Loader />;
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data.length} title="Text Notifications" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        loading={!isLoaded}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default TextNotification;
